import { initComponent } from './core/init-component';

initComponent('.js-ls-hotspot-trigger', (el) => {
  const url = el.dataset.url;
  let lastTouchTime = 0;

  function navigateToProduct(evt: MouseEvent) {
    if (!url) return;
    evt.preventDefault();
    if (evt.metaKey || evt.ctrlKey || evt.button === 1) {
      window.open(url, '_blank', 'noopener');
      return;
    }
    window.location.href = url;
  }

  function deactivateSiblings() {
    el.closest('.js-ls-shop-the-look')
      ?.querySelectorAll<HTMLElement>('.js-ls-hotspot-trigger[data-active]')
      .forEach((t) => t.removeAttribute('data-active'));
  }

  function onTouchEnd(evt: TouchEvent) {
    lastTouchTime = Date.now();
    evt.preventDefault();
    if (el.hasAttribute('data-active')) {
      if (url) window.location.href = url;
    } else {
      deactivateSiblings();
      el.setAttribute('data-active', '');
    }
  }

  function onClick(evt: MouseEvent) {
    if (Date.now() - lastTouchTime < 500) return;
    navigateToProduct(evt);
  }

  function onAuxClick(evt: MouseEvent) {
    if (evt.button === 1) navigateToProduct(evt);
  }

  function onDocumentTouchStart(evt: TouchEvent) {
    if (!el.hasAttribute('data-active')) return;
    if (!el.contains(evt.target as Node)) el.removeAttribute('data-active');
  }

  el.addEventListener('touchend', onTouchEnd);
  el.addEventListener('click', onClick);
  el.addEventListener('auxclick', onAuxClick);
  document.addEventListener('touchstart', onDocumentTouchStart);

  return {
    unload: () => {
      el.removeEventListener('touchend', onTouchEnd);
      el.removeEventListener('click', onClick);
      el.removeEventListener('auxclick', onAuxClick);
      document.removeEventListener('touchstart', onDocumentTouchStart);
    },
  };
});
